export const PathRoot = {
	root: "/",
	product: "/:id",
	notfound: "*",
};
